import type {
    NeglectedOrDelinquentHighSchoolCourseCreditsModel,
} from './NeglectedOrDelinquentInformationModel';

export const COURSE_CREDIT_FIELDS: {
    key: Exclude<
        keyof NeglectedOrDelinquentHighSchoolCourseCreditsModel, 'awardedCourseCredits'
    >;
    label: string;
}[] = [
    { key: 'studentsEarnedCreditsWhileInProgram', label: 'While in the program' },
    {
        key: 'studentsEarnedCreditsWithin90DaysOfExiting',
        label: 'Within 90 Days of Exiting',
    },
];
